/* src/app/app.component.scss */
.header {
  position: fixed;
  width: 100%;
  z-index: 1;
}
.footer {
  box-shadow: 0 0 3px black;
  position: fixed;
  bottom: 0;
  width: 100%;
}
:host ::ng-deep .padding1 {
  height: 2em;
}
app-modal {
  height: 100%;
}
:host ::ng-deep ion-col {
  padding: 0 !important;
}
:host ::ng-deep ion-grid {
  padding: 0 !important;
}
:host ::ng-deep ion-input {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-left: 10px;
  padding-left: 10px !important;
}
.modalClass {
  background: black;
}
:host ::ng-deep .picker-opts {
  min-width: 30vw !important;
}
/*# sourceMappingURL=app.component.css.map */
